import { PipeTransform } from '@angular/core';
var ReferralStatusPipe = /** @class */ (function () {
    function ReferralStatusPipe() {
    }
    ReferralStatusPipe.prototype.transform = function (requestCode, forBoard, completed) {
        if (!requestCode) {
            return '';
        }
        switch (requestCode) {
            case 'REFERRED': // Referred 1st time to responder
                return forBoard ? 'Open' : 'Assigned';
            case 'REFTIMEAPP': // Referred 2nd time to responder (after time approval, typically)
                return forBoard ? 'Open' : 'Assigned (Time Approved)';
            case 'DENIED':
                return forBoard ? (completed ? 'Time Request Board Denied' : 'Processing') : 'Time Request Board Denied';
            case 'UNAVAIL':
                return forBoard ? (completed ? 'Information Unavailable' : 'Processing') : 'Information Unavailable';
            case 'COMPLETED':
                return forBoard ? (completed ? 'Completed (With Response)' : 'Processing') : 'Completed (With Response)';
            case 'CANCELLED':
                return 'Cancelled';
            case 'CLOSEDNONINFO':
                return 'Closed (Non-Information Request)';
            case 'DONEWINFO': // Finished by responder (with answer)
                return forBoard ? 'Processing' : 'Response Submitted';
            case 'DONENOINFO': // Finished by responder (couldn't get info)
                return forBoard ? 'Processing' : 'Information Unavailable';
            case 'NEEDTIME': // Responder has asked for more time. Depending on the request status, this may have been denied.
                return forBoard ? 'Open' : 'Awaiting Time Approval';
            case 'FOLLOWUP': // Requested follow-up by board
                return 'Follow-Up Requested';
            default:
                return forBoard ? 'Open' : 'Not Yet Referred';
        }
    };
    return ReferralStatusPipe;
}());
export { ReferralStatusPipe };
